import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setVoiceCaption } from 'a/reducers/captions';

const useVoiceCaptions = () => {
  const dispatch = useDispatch();

  const startVoiceCaption = useCallback((caption) => {
    dispatch(setVoiceCaption(caption));
  }, []);

  const resetVoiceCaption = useCallback(() => {
    dispatch(setVoiceCaption(''));
  }, []);

  return {
    startVoiceCaption,
    resetVoiceCaption,
  };
};

export default useVoiceCaptions;
